import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import { Box } from '@rsos/base-components';
import { InputStyles } from '@rsos/base-components/form/inputs/InputText/InputText.styles';
import MultiEntryInput from '@rsos/components/capstone/base/form/inputs/MultiEntryInput/MultiEntryInput';
import { WrapperContainer } from '@rsos/components/capstone/base/form/inputs/MultiEntryInput/MultiEntryInput.styles';
import { StyledContainer } from '../../../../MapCard/MapCard.styles';

const CONTAINER_WIDTH = 358;
const TEXTAREA_MAX_HEIGHT = 104;

/**
 * @comonent {{OverridedStyledContainer}} is added as an override to {{StyledContainer}}
 * to ensure that the {{StyledContainer}} has a static width of {358px}
 * when renderred with OutboundSMS as its Child, while other MapCard components
 * continue to use a dynamic width of up to 320px.
 */
export const OverridedStyledContainer = createGlobalStyle`
  ${StyledContainer} {
    max-width: ${CONTAINER_WIDTH}px;
  }
`;

export const Container = styled(Box).attrs({
  width: `${CONTAINER_WIDTH}px`,
})`
  overflow: hidden; // prevent added height and scrolling due to automatic height handling of input the text area
`;

export const PhoneNumberContainer = styled(Box).attrs({
  bg: 'background',
  justify: 'center',
  align: 'start',
  width: '100%',
  px: 3,
  pt: 3,
  border: '1px solid',
  borderColor: 'heavyLineOutline',
  borderRadius: '5px 5px 0px 0px',
  borderBottom: 'none',
})``;

export const SendMsgContainer = styled(Box).attrs({
  bg: 'foreground',
  align: 'end',
  p: '12px',
  horizontal: true,
  border: '1px solid',
  borderColor: 'heavyLineOutline',
  width: '100%',
  borderRadius: '0px 0px 5px 5px',
})``;
export const TextArea = styled.textarea`
  ${InputStyles}
  resize: none;
  overflow: auto;
  max-height: ${TEXTAREA_MAX_HEIGHT}px;
  height: auto;
`;

export const TextAreaContainer = styled.div`
  display: grid;
  width: 100%;
  &::after {
    /* Note the weird space! Needed to preventy jumpy behavior */
    content: attr(data-replicated-value) ' ';

    /* This is how textarea text behaves */
    white-space: pre-wrap;

    /* Hidden from view, clicks, and screen readers */
    visibility: hidden;
  }

  /* Must have same styling to keep size consistent */
  ${TextArea}, &::after {
    font-size: 14px;
    padding: 10px;
    grid-area: 1 / 1 / 2 / 2;
    max-height: ${TEXTAREA_MAX_HEIGHT}px;
  }
`;

/**
 * NOTE: When styling normal React components with styled-components
 * it's essential to pass the `className` prop to the top-level element within the component.
 * this allows styled-components to inject the necessary styles.
 * for more details, refer to the styled-components doc below:
 * @link https://styled-components.com/docs/advanced#styling-normal-react-components
 */

export const CustomMultiEntryInput = styled(MultiEntryInput)`
  ${WrapperContainer} {
    height: 48px;
    overflow: hidden; // prevent slight scrolling of phone field
  }
`;
